// extracted by mini-css-extract-plugin
module.exports = {"container":"flexbox-two-columns_container__UmhgQ","row":"flexbox-two-columns_row__jjmeR","column":"flexbox-two-columns_column__CQtD4"};